import React from 'react';
import Logo from '../../../../assets/brand/vissights-logo.svg';
// import classes from './Logo.css';
const logo = () => (
    <div>
        <img style = {{height: 72}} src={Logo} alt="Logo"/>
    </div>
);
export default logo;
